import React from "react";
import { Spinner } from "react-bootstrap";
import { utils } from "../core/helpers";

import SkillBarChart from "../views/home/components/SkillBarChart";
import SkillStatisticsTable from "../views/home/components/SkillStatisticsTable";

import { useReportsLogic } from "../core/helpers/useReportsLogic";

const Reports: React.FC = () => {
    const {
        user,
        chartData,
        isLoading,
        currentChartIndex,
        nextChart,
        prevChart,
        setCurrentChartIndex
    } = useReportsLogic();

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    const renderStudentCharts = (
        chartData.length > 0 &&
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-12">
                    <div className="card-body">
                        <div
                            className="chart-carousel d-flex d-sm-flex flex-column-reverse flex-sm-row align-items-center justify-content-between">
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm mt-3 mt-sm-0 me-sm-2"
                                onClick={prevChart}
                                aria-label="Previous Chart"
                            >
                                <i className="fa fa-chevron-left" />
                            </button>
                            <div style={{ flexGrow: 1, minHeight: '300px', maxHeight: '550px', width: '100%', maxWidth: '100%' }}>
                                {chartData[currentChartIndex] && <SkillBarChart skillData={chartData[currentChartIndex]} />}
                            </div>
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm mb-3 mb-sm-0 ms-sm-2"
                                onClick={nextChart}
                                aria-label="Next Chart"
                            >
                                <i className="fa fa-chevron-right" />
                            </button>
                        </div>
                        <div className="d-flex justify-content-center mt-3">
                            {chartData.map((_, index) => (
                                <span
                                    key={index}
                                    className={`mx-1 d-inline-block rounded-circle ${index === currentChartIndex ? 'bg-primary' : 'bg-secondary'}`}
                                    style={{ width: '8px', height: '8px', cursor: 'pointer' }}
                                    onClick={() => setCurrentChartIndex(index)}
                                    aria-label={`Go to chart ${index + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    if (!utils.isUserStudent(user!)) {
        return (
            <div className="container my-5">
                <div className="section-header text-center topcategory-sec">
                    <h2>Reports</h2>
                    <p>Reporting is only available for student accounts.</p>
                </div>
            </div>
        );
    }

    return (
        <>
            {renderStudentCharts}
            {chartData.length > 0 && (
                <SkillStatisticsTable chartData={chartData} />
            )}
            {chartData.length === 0 && !isLoading && (
                <div className="container my-5">
                    <div className="section-header text-center topcategory-sec">
                        <h2>No Data Available</h2>
                        <p>Complete some activities to see your progress reports.</p>
                    </div>
                </div>
            )}
        </>
    );
};

export default Reports;